/**
 * Static list of image assets shipped under src/assets. Unlike the icon components (which are
 * enumerated at runtime from the ui-controls module), plain image files aren't discoverable at
 * runtime in this build, so this list is maintained by hand.
 */
export const IMAGE_ASSET_FILENAMES: string[] = [
  'AS_Calendar_Only.png',
  'AS_Enlighten_Only.png',
  'ActivityTypeIcon.png',
  'BidIcon.png',
  'CindyBaker.jpg',
  'Coaching.png',
  'CopilotVideoCallCRM.png',
  'CourtyardMiami.png',
  'Croup.png',
  'Ellipse_4720.png',
  'Facebook_Post.png',
  'Instagram_Post.png',
  'Keypad.png',
  'LoadDishwasher.jpg',
  'MarriottDallas.png',
  'MarriottFlorida.png',
  'MarriottFloridaUpcoming.png',
  'MarriottHawaii.png',
  'MarriottHawaiiUpcoming.png',
  'Negative.png',
  'Negative_old.png',
  'Network_Status_Static_Image.png',
  'NoSuggestion.png',
  'Notification_Static_Screen.png',
  'OverdueIcon.png',
  'Phonolo_13_15 Comparison_Table.png',
  'RemySharp.jpg',
  'Scheduled.png',
  'Static Asset AV Notification.png',
  'Static Asset Conversations.png',
  'Static Asset Directory.png',
  'Static Asset Display And Accessability.png',
  'Static Asset Home.png',
  'Static Asset Queue.png',
  'Static Asset Schedule.png',
  'Static Asset Voice Preference.png',
  'Static Asset WEM.png',
  'Status_Hover.png',
  'Suggestion.png',
  'TimeTableIcon.png',
  'TravisHoward.jpg',
  'Twitter_Post_SS.png',
  'branding-image.png',
  'broken-luggage.png',
  'broken-luggage2.png',
  'canceledIcon.png',
  'curve-image.png',
  'damaged_luggage.png',
  'deleteIcon.png',
  'downloadImage.png',
  'iceland1.png',
  'iceland2.png',
  'illuminateIcon.png',
  'imageIcon.png',
  'liam-reimbursement.png',
  'login-image-2.png',
  'login-image.png',
  'login_background.png',
  'logo.png',
  'lyraLoginImage.png',
  'nowCase.png',
  'overallSummaryGraph.png',
  'static_acd_page.jpg',
  'static_acd_page_navigation.jpg',
  'textAreaIcons.png',
  'typechat.png',
  'voiceTranscriptPlayer.png',
];

/**
 * Function to turn an asset filename into a readable label
 * @param filename - e.g. "branding-image.png"
 * @example humanizeAssetName('branding-image.png')
 * @returns "Branding Image"
 */
export const humanizeAssetName = (filename: string): string => {
  const withoutExtension = filename.replace(/\.[^.]+$/, '');
  return withoutExtension
    .replace(/[-_]+/g, ' ')
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/\s+/g, ' ')
    .trim();
};
